<template>
    <div id="top">
        <div id="wrap_all">
            <div class="container_wrap footer_color" id="footer">
                <div class="container">
                    <div
                        class="flex_column av_one_fourth first el_before_av_one_fourth"
                    >
                        <section
                            id="text-3"
                            class="widget clearfix widget_text"
                        >
                            <div class="textwidget">
                                <p>
                                    <a
                                        href="/"
                                        class="alignnone"
                                        style="
                                            margin: 0px;
                                            padding: 0px;
                                            position: relative;
                                            overflow: hidden;
                                        "
                                        ><img
                                            loading="lazy"
                                            class="alignnone size-full wp-image-266"
                                            src="https://zadbano.pl/wp-content/uploads/2021/01/logo-blue.png"
                                            alt=""
                                            width="300"
                                            height="50" /><span
                                            class="image-overlay overlay-type-extern"
                                            ><span
                                                class="image-overlay-inside"
                                            ></span></span
                                    ></a>
                                </p>
                            </div>
                            <span class="seperator extralight-border"></span>
                        </section>
                    </div>
                    <div
                        class="flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
                    >
                        <section
                            id="custom_html-3"
                            class="widget_text widget clearfix widget_custom_html"
                        >
                            <div class="textwidget custom-html-widget"></div>
                            <span class="seperator extralight-border"></span>
                        </section>
                    </div>
                    <div
                        class="flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
                    >
                        <section
                            id="text-2"
                            class="widget clearfix widget_text"
                        >
                            <div class="textwidget">
                                <p>ul. Wał Miedzeszyński 251</p>
                                <p>04-866 Warszawa</p>
                                <p>
                                    <a href="mailto:kontakt@zadbano.pl"
                                        >kontakt@zadbano.pl</a
                                    >
                                </p>
                                <p>
                                    <a href="tel:+48225261000"
                                        >+48 22 526 1000</a
                                    >
                                </p>
                            </div>
                            <span class="seperator extralight-border"></span>
                        </section>
                    </div>
                    <div
                        class="flex_column av_one_fourth el_after_av_one_fourth el_before_av_one_fourth"
                    >
                        <section
                            id="nav_menu-2"
                            class="widget clearfix widget_nav_menu"
                        >
                            <div class="menu-footer-menu-container">
                                <ul id="menu-footer-menu" class="menu">
                                    <li
                                        id="menu-item-156"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-156"
                                    >
                                        <a href="https://zadbano.pl/o-nas/"
                                            >O nas</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-157"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-157"
                                    >
                                        <a href="https://zadbano.pl/uslugi/"
                                            >Usługi</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-158"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-158"
                                    >
                                        <a
                                            href="https://zadbano.pl/rozwiazania/"
                                            >Rozwiązania</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-159"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-159"
                                    >
                                        <a href="https://zadbano.pl/wspolpraca/"
                                            >Współpraca</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-160"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-160"
                                    >
                                        <a
                                            href="https://zadbano.pl/regulaminy-i-dokumenty/"
                                            >Regulaminy i dokumenty</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-161"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-161"
                                    >
                                        <a
                                            href="https://zadbano.pl/polityka-prywatnosci/"
                                            >Polityka prywatności</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-162"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-162"
                                    >
                                        <a href="https://zadbano.pl/kontakt/"
                                            >Kontakt</a
                                        >
                                    </li>
                                    <li
                                        id="menu-item-163"
                                        class="menu-item menu-item-type-custom menu-item-object-custom menu-item-163"
                                    >
                                        <a href="#">Zaloguj</a>
                                    </li>
                                </ul>
                            </div>
                            <span class="seperator extralight-border"></span>
                        </section>
                    </div>
                </div>

                <!-- ####### END FOOTER CONTAINER ####### -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "pageFooter",
};
</script>



// WEBPACK FOOTER //
// PageFooter.vue?fedd620e